import { render, staticRenderFns } from "./index-old.vue?vue&type=template&id=331308ce&scoped=true"
import script from "./index-old.vue?vue&type=script&lang=js"
export * from "./index-old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331308ce",
  null
  
)

export default component.exports